export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_10.b858071e.png";